import { useContext } from "react";
import { ConfigContext } from "../../contexts/ConfigContext";

export const useTranslation = () => {
  const {
    state: { dictionaryValues },
  } = useContext(ConfigContext);
  const getTextIdTranslation = (textId) => {
    const translation = dictionaryValues[textId] || textId;
    return translation;
  };

  return { getTextIdTranslation };
};
